import React from 'react';
import { connect } from 'react-redux';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';
// @material-ui/icons
import Email from '@material-ui/icons/Email';
import People from '@material-ui/icons/People';
// core components
import Footer from '../../components/Footer/Footer.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import GridItem from '../../components/Grid/GridItem.js';
import Button from '../../components/CustomButtons/Button.js';
import Card from '../../components/Card/Card.js';
import CardBody from '../../components/Card/CardBody.js';
import CardHeader from '../../components/Card/CardHeader.js';
import CardFooter from '../../components/Card/CardFooter.js';
import CustomInput from '../../components/CustomInput/CustomInput.js';

import styles from '../../assets/jss/material-kit-react/views/loginPage.js';

import { handleAddUser } from '../../actions/users';
import { setAuthedUser } from '../../actions/authedUser';

import image from '../../assets/img/bg7.jpg';
import logo from '../../assets/img/logos/PlatoPlanner-logo-white.png';
import { Link } from 'react-router-dom';
import GoogleLogin from 'react-google-login';
require('dotenv').config();

const bcrypt = require('bcryptjs');

const useStyles = makeStyles(styles);

function SignupPage(props) {
  const [cardAnimaton, setCardAnimation] = React.useState('cardHidden');
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [repeatPassword, setRepeatPassword] = React.useState('');
  const [accountSuccess, setAccountSuccess] = React.useState(false);
  const [emailExistsMessage, setEmailExistsMessage] = React.useState(false);
  const [isInvalidCredentials, setIsInvalidCredentials] = React.useState(false);

  var passwordHash = bcrypt.hashSync(password, 8);

  const handleInputChange = (type, value) => {
    switch (type) {
      case 'name':
        setName(value);
        break;
      case 'email':
        setEmail(value);
        break;
      case 'password':
        setPassword(value);
        break;
      case 'repeatPassword':
        setRepeatPassword(value);
        break;
      default:
        break;
    }
  };

  setTimeout(function () {
    setCardAnimation('');
  }, 700);
  const classes = useStyles();

  const emailAlreadyExists = emailId => {
    let emailExists = false;
    Object.keys(props.users).forEach(objectId => {
      if (props.users[objectId].email === emailId) {
        emailExists = true;
      }
    });
    return emailExists;
  };

  const handleClick = () => {
    if (emailAlreadyExists(email)) {
      setEmailExistsMessage(true);
    } else {
      props.dispatch(handleAddUser(name, email, passwordHash));
      setAccountSuccess(true);
    }
  };

  const handleGoogleSuccess = response => {
    const { users } = props;
    const userGoogleEmail = response.profileObj.email;
    const userGoogleName = response.profileObj.name;
    Object.keys(users).forEach(objectId => {
      if (users[objectId].email === userGoogleEmail) {
        props.dispatch(setAuthedUser(userGoogleEmail));
        props.history.push('/categories');
        return;
      }
    });
    props.dispatch(handleAddUser(userGoogleName, userGoogleEmail, ''));
    props.dispatch(setAuthedUser(userGoogleEmail));
    props.history.push('/categories');
  };

  const handleGoogleFailure = response => {
    setIsInvalidCredentials(true);
  };

  const passwordsDoNotMatch = password !== repeatPassword;

  const oneFieldIsEmpty = name === '' || email === '' || password === '';
  return (
    <div>
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: 'url(' + image + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
        }}
      >
        <div className={classes.container}>
          <Link to='/'>
            <img src={logo} alt='platoplanner logo' height='75' width='123' />
          </Link>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes[cardAnimaton]}>
                <form className={classes.form}>
                  <CardHeader color='primary' className={classes.cardHeader}>
                    <h2>Sign Up</h2>
                    <p>Using your Google account</p>
                    <div className={classes.socialLine}>
                      <GoogleLogin
                        clientId='15837099891-d98v6f5vkron8svp8vdfgi8g5d6tb7l1.apps.googleusercontent.com'
                        buttonText=''
                        onSuccess={handleGoogleSuccess}
                        onFailure={handleGoogleFailure}
                        cookiePolicy={'single_host_origin'}
                      />
                    </div>
                  </CardHeader>
                  <p className={classes.divider}>Or old-school way</p>
                  <CardBody>
                    <CustomInput
                      labelText='First Name (required)'
                      id='first'
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: 'text',
                        onChange: e =>
                          handleInputChange('name', e.target.value),
                        endAdornment: (
                          <InputAdornment position='end'>
                            <People className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <CustomInput
                      labelText='Email (required)'
                      id='email'
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: 'email',
                        onChange: e =>
                          handleInputChange('email', e.target.value),
                        endAdornment: (
                          <InputAdornment position='end'>
                            <Email className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <CustomInput
                      labelText='Password (required)'
                      id='pass'
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: 'password',
                        onChange: e =>
                          handleInputChange('password', e.target.value),
                        endAdornment: (
                          <InputAdornment position='end'>
                            <Icon className={classes.inputIconsColor}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                        autoComplete: 'off',
                      }}
                    />
                    <CustomInput
                      labelText='Repeat password (required)'
                      id='pass'
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: 'password',
                        onChange: e =>
                          handleInputChange('repeatPassword', e.target.value),
                        endAdornment: (
                          <InputAdornment position='end'>
                            <Icon className={classes.inputIconsColor}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                        autoComplete: 'off',
                      }}
                    />
                    {passwordsDoNotMatch && (
                      <h4 style={{ color: 'red' }}>
                        The passwords do not match
                      </h4>
                    )}
                    {accountSuccess && (
                      <h4 style={{ color: 'green' }}>
                        Account is created successfully. Please click{' '}
                        <Link to='/login'>here</Link> to go to Login Page.
                      </h4>
                    )}
                    {emailExistsMessage && (
                      <h4 style={{ color: 'red' }}>
                        Email already exists. Please register with another
                        account or click <Link to='/login'>here</Link> to go to
                        Login Page.
                      </h4>
                    )}
                    {isInvalidCredentials && (
                      <h4 style={{ color: 'red' }}>
                        Your email or password is incorrect. Please try again!
                      </h4>
                    )}
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <Button
                      disabled={passwordsDoNotMatch || oneFieldIsEmpty}
                      onClick={handleClick}
                      color='primary'
                      round
                    >
                      Sign Up
                    </Button>
                    <h4>
                      Already have an account? Click <a href='/login'>here</a>{' '}
                      to log in
                    </h4>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        <Footer whiteFont />
      </div>
    </div>
  );
}

function mapStateToProps({ users }) {
  return { users };
}

export default connect(mapStateToProps)(SignupPage);
